import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RecaptchaComponent } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { LevelService } from 'src/app/Services/level.service';

@Component({
  selector: 'app-sblock-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class SblockFormComponent implements OnInit {
  showTitles = true;
  title = 'Formulario De Contacto';
  subtitle = 'Tu consulta llegará directamente al equipo de admisiones.';
  alignTextBlock = 'center';
  titlesColor = '#2B2A6B';
  secondaryColor = '#27A7C2';

  buttonText = 'Enviar';

  /**
   * Google reCAPTCHA v2 site key. Read defensively so the build doesn't break
   * if a given environment file (e.g. staging) hasn't defined it yet; falls back
   * to Google's official test key.
   */
  recaptchaSiteKey =
    (environment as any).recaptchaSiteKey || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
  /** Token returned by reCAPTCHA once the user solves it */
  recaptchaToken: string | null = null;
  @ViewChild(RecaptchaComponent) captchaRef?: RecaptchaComponent;

  /** Section heading shown before the personal-data fields */
  dataSectionTitle = 'Indique sus datos';

  /** Educational levels (GET /public/levels) used by the "Nivel de interés" dropdown */
  levels: any[] = [];
  /** Selected level id — becomes the {id} of POST /public/levels/{id}/inquiry */
  selectedLevelId: number | null = null;

  /** Field values keyed by label (also the keys printed in the inquiry email) */
  values: { [key: string]: string } = {};

  submitting = false;

  formFields = [
    {
      type: 'dropdown_static',
      name: 'Nivel de interés',
      placeholder: 'Seleccioná una opción',
      required: true,
      isLevel: true,
    },
    { type: 'input', name: 'Nombre y apellido', placeholder: '', required: true, half: true },
    { type: 'input', name: 'Teléfono', placeholder: '+54 342....', required: false, half: true },
    { type: 'input', name: 'Email', placeholder: '', required: true },
    { type: 'longtext', name: 'Consulta', placeholder: 'Contanos en qué podemos ayudarte ....', required: false },
  ];

  constructor(
    private levelService: LevelService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadLevels();
  }

  private async loadLevels(): Promise<void> {
    const res = await this.levelService.getLevels();
    const list = res?.data?.data;
    if (Array.isArray(list)) {
      this.levels = list;
    }
  }

  /** Captures the reCAPTCHA token; null when it expires */
  onCaptchaResolved(token: string | null): void {
    this.recaptchaToken = token;
  }

  /** Validate, build the inquiry body and POST it to the selected level */
  async onSubmit(): Promise<void> {
    if (!this.recaptchaToken || this.submitting) {
      return;
    }
    if (!this.selectedLevelId) {
      this.toastr.warning('Seleccioná un nivel de interés.');
      return;
    }
    const missing = this.formFields.some(
      f => f.required && !f.isLevel && !(this.values[f.name] || '').trim()
    );
    if (missing) {
      this.toastr.warning('Completá los campos obligatorios.');
      return;
    }

    const level = this.levels.find(l => l.id === this.selectedLevelId);
    const body: { [key: string]: string } = { 'Nivel de interés': level?.name || '' };
    this.formFields.forEach(f => {
      if (f.isLevel) {
        return;
      }
      const value = (this.values[f.name] || '').trim();
      if (value) {
        body[f.name] = value;
      }
    });

    this.submitting = true;
    try {
      await this.levelService.sendInquiry(this.selectedLevelId, body);
      this.toastr.success('Consulta enviada correctamente.');
      this.resetForm();
    } catch (error) {
      this.toastr.error('No se pudo enviar la consulta. Intentá nuevamente.');
    } finally {
      this.submitting = false;
    }
  }

  private resetForm(): void {
    this.values = {};
    this.selectedLevelId = null;
    this.recaptchaToken = null;
    this.captchaRef?.reset();
  }

  btn1Active = false;
  btn1Es = '';
  btn1Link = '#';

  btn2Active = false;
  btn2Es = '';
  btn2Link = '#';

  btn1Align = 'center';
  linkColor = '#2B2A6B';
}
